import { useData, useDataValue } from "../hooks/useData";
import { Icon } from "../ui/icons";
import { closestIndex, closestKey } from "../utils/dom";
import { Checkbox } from "./Checkbox";
import { Label } from "./Label";

export interface CheckboxListOption {
	id: any,
	title: string,
}

export function CheckboxList(props: {
	prop: string,
	options: CheckboxListOption[],
	
	className?: string,
	disabled?: boolean,
}) {
	const { prop, className, options, disabled } = props;

	const data = useData();
	let value = useDataValue(data, prop);
	if (!value) value = [];

	function handleClick(e: any) {
        if (disabled) return;
		debugger;

		let index = closestIndex(e.target, ".checkbox-container");
		if (index < 0) return;

		const {
            prop,
        } = props;

		// what is current value for this checkbox?
		const o = options[index];
		let i = value.indexOf(o.id);
		let checked = (i >= 0);
		if (checked) {
			// uncheck by removing from value array
			value.splice(i, 1);
		} else {
			// check by adding
			value.push(o.id);
		}

        if (data && prop) {
			data.setValue(prop, [...value]);
        }
	}
	function handleKeyDown(e: any) {
		
	}
	
	const opts = [];
	if (options) {
		let i = 0;
		for(let o of options) {
			let tick = null;
			if (value.indexOf(o.id) >= 0) {
				tick = <Icon type="tick" size="small" />
			}

			const input = (
				<div
					className={[className, "form-control checkbox", disabled ? "disabled" : ""].join(" ")}
					tabIndex={0}
				>
					{tick}
				</div>
			);

			let label;
			if (o.title) {
				label = 
					<Label
						className="checkbox-label"
						title={o.title}
					/>;
			}
		
		
			opts.push(
				<div className="flex group align-start checkbox-container" data-index={i} onClick={handleClick}>
					{label}
					{input}
				</div>
			)

			i++;
		}
	}

	return (
		<div className="checkbox-list">
			{opts}
		</div>
	);
}